import React from 'react';
import { Link } from 'react-router-dom';

// Catch-all fallback for any URL that doesn't match a defined route.
// Before this, unknown paths (e.g. an old `/shop-profile` bookmark or a
// typo) rendered a fully blank white document with no console error —
// diagnosed by test iteration_62.
const NotFound = () => (
  <div
    data-testid="not-found"
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      background: 'var(--bg, #f7f8fa)',
      fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
    }}
  >
    <div
      style={{
        maxWidth: 480,
        width: '100%',
        background: 'var(--card, #fff)',
        border: '1px solid var(--line, #e5e7eb)',
        borderRadius: 14,
        padding: '32px 28px',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 48, fontWeight: 700, letterSpacing: '-0.03em', color: 'var(--acc, #4f46e5)' }}>
        404
      </div>
      <h1 style={{ marginTop: 8, marginBottom: 12, fontSize: 20, fontWeight: 600, color: 'var(--ink, #0f0f13)' }}>
        Page not found
      </h1>
      <p style={{ margin: '0 auto 22px', maxWidth: 340, color: 'var(--mute, #6b7280)', fontSize: 14, lineHeight: 1.5 }}>
        The link you followed may be broken, or the page may have been moved.
      </p>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link
          to="/"
          data-testid="notfound-home"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            padding: '9px 16px',
            background: 'var(--acc, #4f46e5)',
            color: 'white',
            borderRadius: 8,
            fontSize: 13.5,
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          Go home
        </Link>
        <button
          type="button"
          data-testid="notfound-back"
          onClick={() => window.history.back()}
          style={{
            padding: '9px 16px',
            background: 'transparent',
            border: '1px solid var(--line, #e5e7eb)',
            color: 'var(--ink, #0f0f13)',
            borderRadius: 8,
            fontSize: 13.5,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Go back
        </button>
      </div>
    </div>
  </div>
);

export default NotFound;
